import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import { getSpaPathPrefix } from '../../../resources/Constants';
import { Modal, Button } from "react-bootstrap";
import {
    combinarPacientesYEmpresas,
    filtrarPacientesParaModal,
    getNombreClienteFacturacion,
} from "../../../utils/busquedaPacienteFacturacion";
import "./ModalExitoFacturacion.css";

function CrearPresupuesto() {
    const location = useLocation();
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    // Estados del formulario
    const [fechaCreacion, setFechaCreacion] = useState(new Date().toISOString().split('T')[0]);
    const [fechaVence, setFechaVence] = useState(new Date().toISOString().split('T')[0]);
    const [numeroPresupuesto, setNumeroPresupuesto] = useState('');
    const [formaPago, setFormaPago] = useState('Efectivo');
    const [profesional, setProfesional] = useState('');
    const [profesionales, setProfesionales] = useState([]);
    
    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');
    
    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [valorBruto, setValorBruto] = useState(0);
    const [valorTotal, setValorTotal] = useState(0);
    
    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [buscarServicio, setBuscarServicio] = useState('');
    const [mostrarOpcionesServicio, setMostrarOpcionesServicio] = useState(false);
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);
    
    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;

    // Estados para modal de éxito
    const [showModalExito, setShowModalExito] = useState(false);
    const [numeroPresupuestoCreado, setNumeroPresupuestoCreado] = useState('');
    const [presupuestoCreadoId, setPresupuestoCreadoId] = useState(null);
    const [activandoPresupuesto, setActivandoPresupuesto] = useState(false);
    const [presupuestoActivado, setPresupuestoActivado] = useState(false);
    const [showModalCalcDesc, setShowModalCalcDesc] = useState(false);
    const [productoCalcDescId, setProductoCalcDescId] = useState(null);
    const [valorTotalDeseadoModal, setValorTotalDeseadoModal] = useState('');
    const [mensajeErrorCalcDesc, setMensajeErrorCalcDesc] = useState('');
    const history = useHistory();

    const calcularBaseConDescuentoItem = (item) => {
        const precio = parseFloat(item.precio) || 0;
        const cantidad = parseFloat(item.cantidad) || 0;
        const porcentaje = parseFloat(item.porcentaje) || 0;
        const precioBase = precio * cantidad;
        const descuento = precioBase * (porcentaje / 100);
        return precioBase - descuento;
    };

    const calcularBaseAjustadaItem = (item) => {
        const baseConDescuento = calcularBaseConDescuentoItem(item);
        const ajuste = parseFloat(item.ajuste) || 0;
        return baseConDescuento + ajuste;
    };

    const calcularTotalItem = (item) => {
        const baseAjustada = calcularBaseAjustadaItem(item);
        const impuestoPct = parseFloat(item.impuesto) || 0;
        const impuesto = baseAjustada * (impuestoPct / 100);
        return baseAjustada + impuesto;
    };

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Pacientes + empresas (tipo_cliente=1) para presupuestos y nombre en modal
        Promise.all([
            axios.get('/pacientes', { ...config, params: { uid: userdata.user_id } }),
            axios.get('/pacientes', { ...config, params: { uid: userdata.user_id, solo_empresas: true } })
        ])
            .then(([respPacientes, respEmpresas]) => {
                setPacientes(combinarPacientesYEmpresas(respPacientes, respEmpresas));
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos', config)
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    // Cargar datos del paciente si viene desde EstadoCuentaPaciente
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const pacienteIdUrl = urlParams.get('paciente_id');
        
        console.log('Paciente ID desde URL:', pacienteIdUrl);
        
        if (pacienteIdUrl && loggedIn) {
            cargarDatosPaciente(pacienteIdUrl);
        }
    }, [location.search, loggedIn]);

    const cargarDatosPaciente = async (pacienteIdParam) => {
        console.log('Cargando datos del paciente ID:', pacienteIdParam);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        try {
            // Cargar datos del paciente
            const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteIdParam}`, config);
            const pacienteData = pacienteResponse.data[0];
            
            if (pacienteData) {
                // Establecer datos del paciente
                const nombreCompleto = `${pacienteData.primer_nombre || ''} ${pacienteData.segundo_nombre || ''} ${pacienteData.primer_apellido || ''} ${pacienteData.segundo_apellido || ''}`.trim();
                
                setPacienteId(pacienteIdParam);
                setNombrePaciente(nombreCompleto);
                setTipoPaciente(pacienteData.tipo_documento || 'CC');
                setDocumentoPaciente(pacienteData.numero_documento || '');
                
                console.log('Datos del paciente cargados:', nombreCompleto);
            }
        } catch (error) {
            console.error('Error al cargar datos del paciente:', error);
        }
    };

    const getClasificacionesDinamicas = () => {
        const clasificaciones = Array.from(
            new Set(
                listaPrecios
                    .map(item => (item.clasificacion || '').trim())
                    .filter(Boolean)
            )
        );
        return clasificaciones.sort((a, b) => a.localeCompare(b));
    };

    const getListaPreciosFiltrada = () => {
        let filtrada = listaPrecios;

        if (clasificacionFiltro) {
            filtrada = filtrada.filter(item => item.clasificacion === clasificacionFiltro);
        }

        if (buscarServicio.trim()) {
            const term = buscarServicio.toLowerCase();
            filtrada = filtrada.filter(item =>
                (item.nombre || '').toLowerCase().includes(term) ||
                (item.codigo || '').toLowerCase().includes(term)
            );
        }

        return filtrada;
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                clasificacion: servicio.clasificacion || '',
                servicio: servicio.nombre,
                descripcion: '',
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                ajuste: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
            setBuscarServicio('');
            setMostrarOpcionesServicio(false);
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarTextoProducto = (id, campo, valor) => {
        const texto = String(valor ?? '').slice(0, 120);
        setProductos(productos.map((p) => (p.id === id ? { ...p, [campo]: texto } : p)));
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                if (campo === 'ajuste') {
                    // Permite escritura temporal de "-" en el input sin forzar 0.
                    const productoActualizado = { ...p, ajuste: String(valor ?? '') };
                    const ajusteNumerico = parseFloat(productoActualizado.ajuste);
                    const baseConDescuento = calcularBaseConDescuentoItem(productoActualizado);
                    const ajusteMinimo = -baseConDescuento;
                    if (Number.isFinite(ajusteNumerico) && ajusteNumerico < ajusteMinimo) {
                        productoActualizado.ajuste = ajusteMinimo;
                    }
                    productoActualizado.total = calcularTotalItem(productoActualizado);
                    return productoActualizado;
                }
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                productoActualizado.total = calcularTotalItem(productoActualizado);
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const parseNumeroFlexible = (str) => {
        const s = String(str ?? '').trim().replace(/\s/g, '');
        if (!s) return NaN;
        const lastComma = s.lastIndexOf(',');
        let intPart;
        let decPart;
        if (lastComma !== -1) {
            intPart = s.slice(0, lastComma).replace(/\./g, '');
            decPart = s.slice(lastComma + 1).replace(/\./g, '');
        } else {
            intPart = s.replace(/\./g, '');
            decPart = '';
        }
        const num = decPart !== '' ? parseFloat(`${intPart}.${decPart}`) : parseFloat(intPart);
        return Number.isFinite(num) ? num : NaN;
    };

    const abrirModalCalcDescuento = (productoId) => {
        setProductoCalcDescId(productoId);
        setValorTotalDeseadoModal('');
        setMensajeErrorCalcDesc('');
        setShowModalCalcDesc(true);
    };

    const cerrarModalCalcDescuento = () => {
        setShowModalCalcDesc(false);
        setProductoCalcDescId(null);
        setValorTotalDeseadoModal('');
        setMensajeErrorCalcDesc('');
    };

    const aplicarDescuentoPorTotalDeseado = () => {
        setMensajeErrorCalcDesc('');
        if (productoCalcDescId == null) return;
        const prod = productos.find((p) => p.id === productoCalcDescId);
        if (!prod) {
            cerrarModalCalcDescuento();
            return;
        }
        const precioBase = (parseFloat(prod.precio) || 0) * (parseFloat(prod.cantidad) || 0);
        if (precioBase <= 0) {
            setMensajeErrorCalcDesc('Indica cantidad y precio válidos en la fila antes de calcular.');
            return;
        }
        const impuestoPct = parseFloat(prod.impuesto) || 0;
        const factorImpuesto = 1 + impuestoPct / 100;
        const totalMax = precioBase * factorImpuesto;
        const T = parseNumeroFlexible(valorTotalDeseadoModal);
        if (!Number.isFinite(T)) {
            setMensajeErrorCalcDesc('Escribe un valor final válido (puedes usar punto para miles, ej. 19.800.000).');
            return;
        }
        if (T < 0) {
            setMensajeErrorCalcDesc('El valor final no puede ser negativo.');
            return;
        }
        const epsilon = 0.01;
        if (T > totalMax + epsilon) {
            setMensajeErrorCalcDesc(
                `Con el precio y el impuesto actuales, el valor final máximo sin descuento es $ ${totalMax.toLocaleString('es-CO', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}.`
            );
            return;
        }
        const baseDeseada = T / factorImpuesto;
        let porcentaje = 100 * (1 - baseDeseada / precioBase);
        if (!Number.isFinite(porcentaje)) {
            setMensajeErrorCalcDesc('No se pudo calcular el porcentaje.');
            return;
        }
        if (porcentaje < 0) porcentaje = 0;
        if (porcentaje > 100) porcentaje = 100;
        const redondeado = Math.round(porcentaje * 10000) / 10000;
        actualizarProducto(prod.id, 'porcentaje', String(redondeado));
        cerrarModalCalcDescuento();
    };

    const calcularTotales = (productosArray) => {
        let subtotal = 0;
        let totalDescuentos = 0;
        let totalImpuestos = 0;
        let total = 0;

        productosArray.forEach(producto => {
            const precioBase = producto.precio * producto.cantidad;
            const descuento = precioBase * (producto.porcentaje / 100);
            const ajuste = parseFloat(producto.ajuste) || 0;
            const baseConDescuento = precioBase - descuento;
            const baseAjustada = baseConDescuento + ajuste;
            const impuesto = baseAjustada * (producto.impuesto / 100);
            
            subtotal += precioBase;
            totalDescuentos += descuento;
            totalImpuestos += impuesto;
            total += parseFloat(producto.total ?? (baseAjustada + impuesto)) || 0;
        });

        setValorBruto(subtotal);
        setValorTotal(total);
    };

    const getNombreClientePresupuesto = getNombreClienteFacturacion;

    const getPacientesFiltrados = () =>
        filtrarPacientesParaModal(pacientes, busquedaPaciente);

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        const inicio = (paginaActual - 1) * pacientesPorPagina;
        const fin = inicio + pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = getNombreClientePresupuesto(paciente);
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setShowModalPaciente(false);
    };

    // Funciones para modal de éxito
    const handleShowModalExito = () => setShowModalExito(true);
    const handleCloseModalExito = () => setShowModalExito(false);

    const handleActivarPresupuesto = async () => {
        if (!presupuestoCreadoId) return;
        setActivandoPresupuesto(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };
        try {
            const response = await axios.put('/presupuesto/' + presupuestoCreadoId + '/estado', { estado: 1 }, config);
            if (response.data.success) {
                setPresupuestoActivado(true);
            }
        } catch (error) {
            alert('Error al aprobar: ' + (error.response?.data?.message || error.message));
        } finally {
            setActivandoPresupuesto(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!pacienteId) {
            alert('Por favor seleccione un paciente');
            return;
        }
        
        if (productos.length === 0) {
            alert('Debe agregar al menos un servicio');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        const presupuestoData = {
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            client_id: client.client_id,
            fecha_creacion: fechaCreacion,
            fecha_vence: fechaVence,
            forma_pago: formaPago,
            valor_bruto: parseFloat(valorBruto),
            valor_total: parseFloat(valorTotal),
            observaciones: observaciones || '',
            detalle: productos.map(producto => ({
                descripcion: (producto.descripcion || '').trim() || null,
                id_listadeprecios: parseInt(producto.id_listadeprecios),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                ajuste: parseFloat(producto.ajuste) || 0,
                total: parseFloat(producto.total)
            }))
        };

        try {
            const response = await axios.post('/presupuesto', presupuestoData, config);
            if (response.status === 200 || response.status === 201) {
                // Guardar número y ID de presupuesto creado
                setNumeroPresupuestoCreado(response.data.numero_presupuesto);
                setPresupuestoCreadoId(response.data.presupuesto_id);
                setPresupuestoActivado(false);
                
                // Limpiar formulario
                setProductos([]);
                setPacienteId('');
                setNombrePaciente('');
                setDocumentoPaciente('');
                setObservaciones('');
                setValorBruto(0);
                setValorTotal(0);
                setNumeroPresupuesto('');
                
                // Mostrar modal de éxito
                setTimeout(() => { handleShowModalExito() }, 500);
            }
        } catch (error) {
            console.error('Error completo:', error);
            alert('Error al guardar el presupuesto: ' + (error.response?.data?.message || error.message));
        }
    };

    if (loggedIn) {
        return (
            <div className="hold-transition presupuesto-page">
                <style>{`
                    .presupuesto-page { font-size: 12.5px; }
                    .presupuesto-page .content-header h1 {
                        font-size: 1.95rem !important;
                        font-weight: 800 !important;
                        margin-bottom: 0 !important;
                    }
                    .presupuesto-page label {
                        font-size: 0.76rem;
                        font-weight: 700;
                        color: #6c757d;
                        margin-bottom: 6px;
                        text-transform: uppercase;
                        letter-spacing: .03rem;
                    }
                    .presupuesto-page .form-control {
                        font-size: 0.82rem !important;
                        padding: 0.38rem 0.68rem !important;
                        min-height: 36px;
                    }
                    .presupuesto-page .btn { font-size: 0.82rem !important; }
                    .presupuesto-soft-card {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.05) !important;
                        box-shadow: 0 10px 24px rgba(0,0,0,0.04) !important;
                    }
                    .presupuesto-soft-header {
                        background: #fff;
                        border-bottom: 1px solid rgba(0,0,0,0.06);
                    }
                    .chip-row {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                    }
                    .chip-filter {
                        border: 1px solid rgba(23,162,184,0.25);
                        background: rgba(23,162,184,0.06);
                        color: #17a2b8;
                        border-radius: 999px;
                        padding: 5px 12px;
                        font-size: 0.75rem;
                        font-weight: 700;
                        cursor: pointer;
                    }
                    .chip-filter.active {
                        background: #17a2b8;
                        color: #fff;
                        border-color: #17a2b8;
                    }
                    .budget-main-title {
                        margin: 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 1rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .budget-main-title .title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 9px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(23,162,184,0.1);
                        color: #17a2b8;
                        font-size: 0.85rem;
                    }
                    .budget-section-title {
                        margin: 0 0 14px 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 0.95rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .budget-section-title .title-icon {
                        width: 26px;
                        height: 26px;
                        border-radius: 8px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(50,58,69,0.08);
                        color: #323a45;
                        font-size: 0.78rem;
                    }
                    .factura-lineas-table .factura-col-accion-head,
                    .factura-lineas-table .factura-col-accion-body {
                        width: 44px;
                        min-width: 44px;
                        max-width: 44px;
                        padding: 6px 4px !important;
                        text-align: center;
                        vertical-align: middle !important;
                        white-space: nowrap;
                    }
                    .factura-total-label-cell {
                        border: none !important;
                        text-align: right;
                        vertical-align: middle !important;
                        padding: 3px 8px !important;
                        font-size: 0.72rem;
                        font-weight: 400;
                        color: #6c757d;
                        white-space: nowrap;
                        min-width: 96px;
                        line-height: 1.25;
                    }
                    .factura-total-value-cell {
                        border: none !important;
                        padding: 3px 0 !important;
                        vertical-align: middle !important;
                    }
                    .factura-total-value-input {
                        width: 100%;
                        max-width: 100%;
                        text-align: right;
                        font-size: 0.72rem;
                        font-weight: 400;
                        color: #495057;
                        background-color: #f8f9fa !important;
                        padding: 0.25rem 0.35rem !important;
                        min-height: 28px !important;
                    }
                    .factura-total-value-input.factura-total-final {
                        font-size: 0.75rem;
                        font-weight: 600;
                        color: #17a2b8;
                    }
                    .factura-lineas-table {
                        table-layout: fixed;
                        border-collapse: collapse;
                    }
                    .factura-lineas-table th,
                    .factura-lineas-table td {
                        border: none !important;
                    }
                    .factura-lineas-table {
                        font-size: 0.75rem;
                    }
                    .factura-lineas-table thead th {
                        border-bottom: 1px solid #dee2e6 !important;
                        padding-bottom: 8px;
                        font-size: 0.7rem;
                        font-weight: 600;
                        color: #6c757d;
                    }
                    .factura-lineas-table .factura-col-servicio,
                    .factura-lineas-table .factura-col-descripcion {
                        text-align: center;
                        vertical-align: top;
                        font-size: 0.72rem;
                        padding: 6px 8px;
                        line-height: 1.3;
                        word-break: break-word;
                    }
                    .factura-lineas-table .factura-col-servicio {
                        min-width: 120px;
                        max-width: 180px;
                    }
                    .factura-lineas-table .factura-col-descripcion {
                        min-width: 110px;
                        max-width: 160px;
                    }
                    .factura-lineas-table .factura-input-descripcion {
                        width: 100% !important;
                        min-width: 0 !important;
                        min-height: 30px !important;
                        max-height: 4.5rem;
                        padding: 0.25rem 0.35rem !important;
                        font-size: 0.72rem !important;
                        line-height: 1.3;
                        resize: none;
                        overflow-wrap: anywhere;
                        word-break: break-word;
                        white-space: pre-wrap;
                    }
                    .factura-lineas-table tfoot tr:first-child td {
                        border-top: 1px solid #e9ecef !important;
                        padding-top: 10px;
                    }
                    .factura-lineas-table .factura-col-cant,
                    .factura-lineas-table .factura-col-desc {
                        width: 72px;
                        max-width: 72px;
                    }
                    .factura-lineas-table .factura-col-precio {
                        width: 118px;
                        max-width: 118px;
                    }
                    .factura-lineas-table .factura-input-cant,
                    .factura-lineas-table .factura-input-desc {
                        width: 100% !important;
                        max-width: 64px !important;
                        min-width: 0 !important;
                        min-height: 32px !important;
                        padding: 0.28rem 0.35rem !important;
                        margin: 0 auto;
                        text-align: center;
                        -moz-appearance: textfield;
                    }
                    .factura-lineas-table .factura-input-precio {
                        width: 100% !important;
                        max-width: 110px !important;
                        min-height: 32px !important;
                        padding: 0.28rem 0.4rem !important;
                        text-align: right;
                        -moz-appearance: textfield;
                    }
                    .factura-lineas-table .factura-input-cant::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-cant::-webkit-inner-spin-button,
                    .factura-lineas-table .factura-input-desc::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-desc::-webkit-inner-spin-button,
                    .factura-lineas-table .factura-input-precio::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-precio::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-presupuestos">Listado de Presupuestos</Link></li>
                                        <li className="breadcrumb-item active">Crear Presupuesto</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Presupuesto</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            <div className="card card-info card-outline presupuesto-soft-card">
                                <div className="card card-info-outline">
                                    <div className="card-header presupuesto-soft-header">
                                        <h5 className="budget-main-title">
                                            <span className="title-icon"><i className="fas fa-file-invoice"></i></span>
                                            Información del Presupuesto
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            
                                            <h5 className="budget-section-title">
                                                <span className="title-icon"><i className="fas fa-user"></i></span>
                                                Información del Paciente
                                            </h5>
                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <label>&nbsp;</label>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info form-control"
                                                            onClick={() => setShowModalPaciente(true)}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Fecha de Creación *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fechaCreacion}
                                                            onChange={(e) => setFechaCreacion(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Fecha de Vencimiento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fechaVence}
                                                            onChange={(e) => setFechaVence(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Profesional *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={profesional}
                                                            onChange={(e) => setProfesional(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {profesionales.map(prof => (
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                {/* Primera fila: Clasificación dinámica */}
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label>Clasificación</label>
                                                        <div className="chip-row mb-2">
                                                            <button
                                                                type="button"
                                                                className={`chip-filter ${clasificacionFiltro === '' ? 'active' : ''}`}
                                                                onClick={() => setClasificacionFiltro('')}
                                                            >
                                                                Todas
                                                            </button>
                                                            {getClasificacionesDinamicas().map((clas) => (
                                                                <button
                                                                    key={clas}
                                                                    type="button"
                                                                    className={`chip-filter ${clasificacionFiltro === clas ? 'active' : ''}`}
                                                                    onClick={() => setClasificacionFiltro(clas)}
                                                                >
                                                                    {clas}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Segunda fila: Selector con búsqueda integrada + Botón */}
                                                <div className="row mt-2">
                                                    <div className="col-md-10">
                                                        <label>Selecciona el Servicio</label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Buscar y seleccionar servicio (código o nombre)..."
                                                                value={buscarServicio}
                                                                onFocus={() => setMostrarOpcionesServicio(true)}
                                                                onBlur={() => setTimeout(() => setMostrarOpcionesServicio(false), 150)}
                                                                onChange={(e) => {
                                                                    setBuscarServicio(e.target.value);
                                                                    setProductoSeleccionado('');
                                                                    setMostrarOpcionesServicio(true);
                                                                }}
                                                            />

                                                            {mostrarOpcionesServicio && (
                                                                <div
                                                                    className="shadow-sm"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        zIndex: 1000,
                                                                        width: '100%',
                                                                        maxHeight: '260px',
                                                                        overflowY: 'auto',
                                                                        background: '#fff',
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '10px',
                                                                        marginTop: '4px'
                                                                    }}
                                                                >
                                                                    {getListaPreciosFiltrada().length === 0 ? (
                                                                        <div style={{ padding: '10px 12px', color: '#8c8c8c', fontSize: '0.85rem' }}>
                                                                            No hay servicios para tu búsqueda.
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {getListaPreciosFiltrada().slice(0, 30).map(servicio => (
                                                                                <button
                                                                                    key={servicio.id}
                                                                                    type="button"
                                                                                    onMouseDown={() => {
                                                                                        setProductoSeleccionado(servicio.id);
                                                                                        setBuscarServicio(`${servicio.codigo || ''} - ${servicio.nombre || ''}`.trim());
                                                                                        setMostrarOpcionesServicio(false);
                                                                                    }}
                                                                                    style={{
                                                                                        display: 'block',
                                                                                        width: '100%',
                                                                                        textAlign: 'left',
                                                                                        border: 'none',
                                                                                        background: 'transparent',
                                                                                        padding: '8px 12px',
                                                                                        borderBottom: '1px solid #f3f3f3',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <span style={{ fontWeight: 600, color: '#323a45' }}>{servicio.codigo}</span>
                                                                                    <span style={{ color: '#8c8c8c' }}> - {servicio.nombre}</span>
                                                                                </button>
                                                                            ))}
                                                                            {getListaPreciosFiltrada().length > 30 && (
                                                                                <div style={{ padding: '8px 12px', color: '#8c8c8c', fontSize: '0.75rem', background: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                                                                                    Mostrando 30 de {getListaPreciosFiltrada().length} resultados. Escribe más para refinar.
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>&nbsp;</label>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info btn-block"
                                                            onClick={agregarServicio}
                                                            disabled={!productoSeleccionado}
                                                        >
                                                            Agregar Servicio
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            {/* Tabla de productos */}
                                            <div className="table-responsive" style={{overflowX: 'auto'}}>
                                                <table className="table factura-lineas-table" style={{minWidth: '1080px'}}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center" style={{width: '11%', minWidth: '96px'}}>Clasificación</th>
                                                            <th className="text-center factura-col-servicio">Servicio</th>
                                                            <th className="text-center factura-col-descripcion">Descripción</th>
                                                            <th className="text-center factura-col-cant">Cant.</th>
                                                            <th className="text-center factura-col-precio">Precio</th>
                                                            <th className="text-center factura-col-desc">Desc %</th>
                                                            <th className="text-center" style={{width: '9%', minWidth: '88px'}}>Ajuste</th>
                                                            <th className="text-center" style={{width: '10%', minWidth: '95px'}}>Impuesto</th>
                                                            <th className="text-center" style={{width: '14%', minWidth: '120px'}}>Total</th>
                                                            <th className="text-center factura-col-accion-head"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productos.map(producto => (
                                                            <tr key={producto.id}>
                                                                <td>
                                                                    <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                                                        <span
                                                                            className="text-truncate"
                                                                            style={{ minWidth: 0 }}
                                                                            title={producto.clasificacion || 'N/A'}
                                                                        >
                                                                            {producto.clasificacion || 'N/A'}
                                                                        </span>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-info btn-sm p-1"
                                                                            style={{ flexShrink: 0, lineHeight: 1 }}
                                                                            title="Ajustar precio final: calcular el % de descuento según el valor final con impuestos"
                                                                            aria-label="Ajustar precio final por descuento"
                                                                            onClick={() => abrirModalCalcDescuento(producto.id)}
                                                                        >
                                                                            <i className="fas fa-calculator"></i>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                                <td className="factura-col-servicio">{producto.servicio}</td>
                                                                <td className="factura-col-descripcion">
                                                                    <textarea
                                                                        rows={2}
                                                                        className="form-control form-control-sm factura-input-descripcion"
                                                                        value={producto.descripcion || ''}
                                                                        maxLength={120}
                                                                        onChange={(e) => actualizarTextoProducto(producto.id, 'descripcion', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td className="text-center factura-col-cant">
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm factura-input-cant" 
                                                                        value={producto.cantidad}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                        min="1"
                                                                        max="999"
                                                                    />
                                                                </td>
                                                                <td className="text-right factura-col-precio">
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm factura-input-precio" 
                                                                        value={producto.precio}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                        step="0.01"
                                                                    />
                                                                </td>
                                                                <td className="text-center factura-col-desc">
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm factura-input-desc" 
                                                                        value={producto.porcentaje}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                        min="0"
                                                                        max="100"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm"
                                                                        value={producto.ajuste ?? ''}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'ajuste', e.target.value)}
                                                                        step="0.01"
                                                                        min={-calcularBaseConDescuentoItem(producto)}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <select 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.impuesto}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                        style={{ textAlign: 'center', textAlignLast: 'center' }}
                                                                    >
                                                                        <option value="0">0</option>
                                                                        {impuestos.map(imp => (
                                                                            <option key={imp.id} value={imp.impuesto}>{imp.nombre+' '+imp.impuesto+'%'}</option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td className="text-right">
                                                                    $ {parseFloat(producto.total || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                </td>
                                                                <td className="factura-col-accion-body">
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn p-0 border-0 bg-transparent text-danger"
                                                                        onClick={() => eliminarProducto(producto.id)}
                                                                        title="Eliminar servicio"
                                                                    >
                                                                        <i className="fas fa-trash-alt"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">Subtotal:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control form-control-sm factura-total-value-input" 
                                                                    value={'$ ' + parseFloat(valorBruto || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">Descuento{'\u00A0'}:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control form-control-sm factura-total-value-input" 
                                                                    value={'$ ' + productos.reduce((sum, p) => sum + ((p.precio * p.cantidad) * (p.porcentaje / 100)), 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">Ajuste:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm factura-total-value-input"
                                                                    value={'$ ' + productos.reduce((sum, p) => sum + (parseFloat(p.ajuste) || 0), 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">IVA:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control form-control-sm factura-total-value-input" 
                                                                    value={'$ ' + productos.reduce((sum, p) => {
                                                                        const precioBase = (parseFloat(p.precio) || 0) * (parseFloat(p.cantidad) || 0);
                                                                        const descuento = precioBase * ((parseFloat(p.porcentaje) || 0) / 100);
                                                                        const baseAjustada = (precioBase - descuento) + (parseFloat(p.ajuste) || 0);
                                                                        return sum + (baseAjustada * ((parseFloat(p.impuesto) || 0) / 100));
                                                                    }, 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">Total:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control form-control-sm factura-total-value-input factura-total-final" 
                                                                    value={'$ ' + parseFloat(valorTotal || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea 
                                                    className="form-control" 
                                                    rows="5"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder=""
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-info mr-2">
                                                    Guardar Presupuesto
                                                </button>
                                                <Link to="/listado-presupuestos" className="btn btn-secondary">
                                                    Cancelar
                                                </Link>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                <Modal show={showModalCalcDesc} onHide={cerrarModalCalcDescuento} centered size="sm">
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: '1rem' }}>
                            <i className="fas fa-calculator mr-2 text-info" aria-hidden="true"></i>
                            Ajustar precio final por descuento
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {productoCalcDescId != null && (
                            <>
                                <div className="alert alert-info py-2 px-2 small mb-2" role="note">
                                    Ingresa el valor total final que deseas obtener para este ítem. El sistema calculará automáticamente el porcentaje de descuento necesario para alcanzar ese precio.
                                </div>
                                <p className="small mb-3">
                                    <strong>Ítem:</strong>{' '}
                                    {productos.find((p) => p.id === productoCalcDescId)?.servicio || '—'}
                                    <br />
                                    <strong>Total actual:</strong>{' '}
                                    ${' '}
                                    {parseFloat(
                                        productos.find((p) => p.id === productoCalcDescId)?.total || 0
                                    ).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </p>
                                <div className="form-group mb-2">
                                    <label className="small font-weight-bold mb-1">Valor final deseado (con impuestos)</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={valorTotalDeseadoModal}
                                        onChange={(e) => setValorTotalDeseadoModal(e.target.value)}
                                        placeholder="Ej: 19800000 o 19.800.000"
                                        autoComplete="off"
                                    />
                                </div>
                                {mensajeErrorCalcDesc ? (
                                    <div className="alert alert-warning py-2 px-2 small mb-0" role="alert">
                                        {mensajeErrorCalcDesc}
                                    </div>
                                ) : null}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="py-2">
                        <Button variant="secondary" size="sm" type="button" onClick={cerrarModalCalcDescuento}>
                            Cancelar
                        </Button>
                        <Button variant="info" size="sm" type="button" onClick={aplicarDescuentoPorTotalDeseado}>
                            Calcular y aplicar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Éxito */}
                <Modal
                    show={showModalExito}
                    onHide={handleCloseModalExito}
                    centered
                    dialogClassName="mx-exito-dialog"
                    contentClassName="mx-exito-content"
                >
                    <Modal.Header closeButton className="mx-exito-head">
                        <Modal.Title>
                            <span className="mx-exito-head-icon">
                                <i className="fas fa-check"></i>
                            </span>
                            Presupuesto guardado
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="mx-exito-body">
                        <div className="mx-exito-hero" aria-hidden="true">
                            <i className="fas fa-check"></i>
                        </div>
                        <h5 className="mx-exito-title">Presupuesto guardado exitosamente</h5>
                        <p className="mx-exito-label mb-0">Número de Presupuesto:</p>
                        <div className="mx-exito-numero">{numeroPresupuestoCreado || '—'}</div>

                        {!presupuestoActivado ? (
                            <Button
                                className="mx-exito-btn-primary"
                                onClick={handleActivarPresupuesto}
                                disabled={activandoPresupuesto}
                            >
                                {activandoPresupuesto ? (
                                    <><i className="fas fa-spinner fa-spin mr-2"></i>Aprobando...</>
                                ) : (
                                    <><i className="fas fa-check mr-2"></i>Aprobar Presupuesto</>
                                )}
                            </Button>
                        ) : (
                            <div className="mx-exito-alert-ok">
                                <i className="fas fa-check-circle"></i>
                                Presupuesto aprobado. El saldo ha sido cargado al paciente.
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer className="mx-exito-footer">
                        <Button
                            className="mx-exito-btn-outline mx-exito-btn-outline--teal"
                            onClick={() => {
                                handleCloseModalExito();
                                if (!presupuestoCreadoId) {
                                    alert('No se encontró el ID del presupuesto para abrir la vista previa.');
                                    return;
                                }
                                const prefix = getSpaPathPrefix();
                                const url = `${window.location.origin}${prefix}/#/vista-previa-presupuesto/${presupuestoCreadoId}`;
                                window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
                            }}
                        >
                            <i className="fas fa-print mr-2"></i>
                            Imprimir
                        </Button>
                        <Button
                            className="mx-exito-btn-outline mx-exito-btn-outline--gray"
                            onClick={() => {
                                handleCloseModalExito();
                                history.push('/listado-presupuestos');
                            }}
                        >
                            <i className="fas fa-arrow-left mr-2"></i>
                            Volver
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal para seleccionar paciente */}
                {showModalPaciente && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar Paciente</h5>
                                    <button type="button" className="close" onClick={() => setShowModalPaciente(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group mb-3">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por nombre o documento..."
                                            value={busquedaPaciente}
                                            onChange={(e) => {
                                                setBusquedaPaciente(e.target.value);
                                                setPaginaActual(1);
                                            }}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            height: 'min(52vh, 420px)',
                                            overflowY: 'scroll',
                                            scrollbarGutter: 'stable',
                                        }}
                                    >
                                        <table className="table table-hover table-sm table-borderless mb-0">
                                            <thead className="thead-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Documento</th>
                                                    <th className="text-center" style={{ width: '56px' }}>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getPacientesPaginados().map((paciente) => (
                                                    <tr key={paciente.id ?? `${paciente.numero_documento}-${getNombreClientePresupuesto(paciente)}`}>
                                                        <td>{getNombreClientePresupuesto(paciente)}</td>
                                                        <td>{paciente.numero_documento}</td>
                                                        <td className="text-center align-middle">
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-sm btn-success"
                                                                title="Seleccionar paciente"
                                                                aria-label="Seleccionar paciente"
                                                                onClick={() => seleccionarPaciente(paciente)}
                                                            >
                                                                <i className="fas fa-check"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {getPacientesPaginados().length === 0 && (
                                                    <tr>
                                                        <td colSpan="3" className="text-center text-muted py-4">
                                                            No hay resultados para la búsqueda.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {/* Paginación */}
                                    {getTotalPaginas() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === 1}
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === getTotalPaginas()}
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalPaciente(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default CrearPresupuesto;